import { Routes, Route } from "react-router-dom";

import { Services } from "./";

export { ServicesLayout };

function ServicesLayout() {
  return (
    <div className="p-4">
      <div className="container">
        <Routes>
          <Route index element={<Services />} />
        </Routes>
      </div>
    </div>
  );
}
